import { render } from "./MultipleSelect.vue?vue&type=template&id=3e8867ae&scoped=true&ts=true"
import script from "./MultipleSelect.vue?vue&type=script&lang=ts"
export * from "./MultipleSelect.vue?vue&type=script&lang=ts"

import "./MultipleSelect.vue?vue&type=style&index=0&id=3e8867ae&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8867ae"]])

export default __exports__